import { styled } from '@mui/material/styles';

export const ThumbnailCardFrame = styled('figure')({
    margin: 0,
    padding: '4px 4px 40px',
    backgroundColor: '#fff',
    border: '1px solid #ddd',
    borderRadius: '4px',
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.12), 0 1px 3px rgba(0, 0, 0, 0.08)'
});

export const ThumbnailArea = styled('div')({
    position: 'relative',
    width: '100%',
    aspectRatio: '3 / 2',
    backgroundColor: '#ededed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden'
});
